import { action } from 'satcheljs';
export var signatureSaved = action('SIGNATURE_SAVED');
//# sourceMappingURL=signatureSaved.js.map